import { EXPERIENCE_STATES, MENU_ITEMS } from "constants/experiences"

export const formatDuration = (tripLength, availableHours) => {
  if (tripLength === "full_day") return "Full day"
  if (tripLength === "half_day") return "Half day"
  return availableHours && availableHours.length > 0
    ? `${availableHours[0].start} - ${availableHours[0].end}`
    : "Varies"
}

/**
 * Display label for an experience's "terms" / duration in the card, listing
 * table and preview. Multi-day experiences show their day count (or "Multi-Day")
 * instead of an hours range, which only applies to single-day experiences.
 *
 * @param {Object} record - trip/experience record
 * @param {Function} [t] - i18n translation function (optional; falls back to English)
 */
export const formatExperienceTerms = (record, t) => {
  const translate = typeof t === "function" ? t : (_key, opts) => opts?.defaultValue
  if (record?.duration_type === "multi_day") {
    const days = Number(record?.duration_value)
    if (days > 0) {
      return translate("experiences.terms.days", { count: days, defaultValue: `${days} Days` })
    }
    return translate("experiences.terms.multi_day", { defaultValue: "Multi-Day" })
  }
  return record?.available_hours_range ?? "—"
}

export const formatTimeDuration = (minutes) => {
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hrs && mins) return `${hrs}h ${mins}m`;
  if (hrs) return `${hrs}h`;
  if (mins) return `${mins}m`;
  return "0m";
};

export const getActionConditions = (status) => {
  switch (status) {
    case EXPERIENCE_STATES.published:
      return {
        [MENU_ITEMS.EDIT_CATEGORY]: true,
        [MENU_ITEMS.SHARE]: true,
        [MENU_ITEMS.DUPLICATE]: true,
        [MENU_ITEMS.DEACTIVATE]: true,
        [MENU_ITEMS.DELETE]: true,
        [MENU_ITEMS.PUBLISH]: false
      }
    case EXPERIENCE_STATES.draft:
      return {
        [MENU_ITEMS.EDIT_CATEGORY]: false,
        [MENU_ITEMS.SHARE]: false,
        [MENU_ITEMS.DUPLICATE]: false,
        [MENU_ITEMS.DEACTIVATE]: false,
        [MENU_ITEMS.DELETE]: true,
        [MENU_ITEMS.PUBLISH]: false
      }
    case EXPERIENCE_STATES.deactivated:
      return {
        [MENU_ITEMS.EDIT_CATEGORY]: false,
        [MENU_ITEMS.SHARE]: false,
        [MENU_ITEMS.DUPLICATE]: false,
        [MENU_ITEMS.DEACTIVATE]: false,
        [MENU_ITEMS.DELETE]: true,
        [MENU_ITEMS.PUBLISH]: true
      }
    default:
      return {
         [MENU_ITEMS.EDIT_CATEGORY]: true,
         [MENU_ITEMS.PUBLISH]: true,
        [MENU_ITEMS.SHARE]: true,
        [MENU_ITEMS.DUPLICATE]: true,
        [MENU_ITEMS.DEACTIVATE]: true,
        [MENU_ITEMS.DELETE]: true,
      }
  }
}

export const getDropdownItems = (menuConfig, conditions) => {
  return Object.values(menuConfig)
    .map(item => ({
      ...item,
      icon: <item.icon />,
      condition: conditions[item.key]
    }))
    .filter(item => item.condition)
} 
